import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  getAllCandidates,
  getAllRequisitions,
  getJobsForCandidate,
  getCandidatesForJob,
  unassignCandidate,
  getAllStatuses,
  updateCandidateStatus,
  getRecruiterMappings,
} from "../services/api";
import "../styles/Logs.scss";
import Swal from "sweetalert2";

function Logs() {
  const [logType, setLogType] = useState(null);
  const [candidates, setCandidates] = useState([]);
  const [requisitions, setRequisitions] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [selectedRequisition, setSelectedRequisition] = useState(null);
  const [jobsForCandidate, setJobsForCandidate] = useState([]);
  const [candidatesForJob, setCandidatesForJob] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [statusModalCandidate, setStatusModalCandidate] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [remarks, setRemarks] = useState("");

  const roleId = localStorage.getItem("role_id");
  // Logtype options
  const logTypeOptions = [
    { value: "candidate", label: "Candidate Log" },
    { value: "requisition", label: "Requisition Log" },
  ];

  // Remove the useEffect that fetches statuses on component mount

  // for logtype changes - for dropdown
  const handleLogTypeChange = (selected) => {
    setLogType(selected);
    setSelectedCandidate(null);
    setSelectedRequisition(null);
    setJobsForCandidate([]);
    setCandidatesForJob([]);

    // Call APIs based on log type selection
    if (selected?.value === "candidate") {
      fetchCandidates();
    } else if (selected?.value === "requisition") {
      fetchRequisitions();
    }
  };

  // To get all candidates info
  const fetchCandidates = async () => {
    try {
      Swal.fire({
        html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });
      const response = await getAllCandidates();
      Swal.close();
      if (
        response &&
        response.result_code === 200 &&
        Array.isArray(response.result_info)
      ) {
        const candidateOptions = response.result_info.map((candidate) => ({
          value: candidate.id,
          label: `${candidate.candidate_name} (${candidate.email})`,
          ...candidate,
        }));
        setCandidates(candidateOptions);
      }
    } catch (error) {
      console.error("Error fetching candidates:", error);
    }
  };

  // To get All Job requisitions info
  const fetchRequisitions = async () => {
    try {
      Swal.fire({
        html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader" />`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });
      const response = await getAllRequisitions();
      Swal.close();
      if (
        response &&
        response.result_code === 200 &&
        Array.isArray(response.result_info)
      ) {
        const requisitionOptions = response.result_info.map((req) => ({
          value: req.id,
          label: `${req.job_id} - ${req.job_title}`,
          ...req,
        }));
        setRequisitions(requisitionOptions);
      }
    } catch (error) {
      console.error("Error fetching requisitions:", error);
    }
  };

  // To get info about jobs for a particular candidate
  const handleCandidateChange = async (selected) => {
    setSelectedCandidate(selected);
    if (selected) {
      setLoading(true);
      try {
        Swal.fire({
          html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
          showConfirmButton: false,
          heightAuto: false,
          customClass: { popup: "loader-swal" },
          allowOutsideClick: false,
        });
        const response = await getJobsForCandidate(selected.value);
        Swal.close();
        if (
          response &&
          response.result_code === 200 &&
          Array.isArray(response.result_info)
        ) {
          setJobsForCandidate(response.result_info);
        } else {
          setJobsForCandidate([]);
        }
      } catch (error) {
        console.error("Error fetching jobs for candidate:", error);
        setJobsForCandidate([]);
      } finally {
        setLoading(false);
      }
    } else {
      setJobsForCandidate([]);
    }
  };

  // To get info about candidates for particular Job
  const handleRequisitionChange = async (selected) => {
    setSelectedRequisition(selected);
    if (selected) {
      console.log("Selected Requisition:", selected);
      setLoading(true);
      try {
        Swal.fire({
          html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
          showConfirmButton: false,
          heightAuto: false,
          customClass: { popup: "loader-swal" },
          allowOutsideClick: false,
        });
        const response = await getCandidatesForJob(selected.value);
        console.log("Response for candidates:", response);

        Swal.close();
        if (
          response &&
          response.result_code === 200 &&
          Array.isArray(response.result_info)
        ) {
          setCandidatesForJob(response.result_info);
        } else {
          setCandidatesForJob([]);
        }
      } catch (error) {
        console.error("Error fetching candidates for job:", error);
        setCandidatesForJob([]);
      } finally {
        setLoading(false);
      }
    } else {
      setCandidatesForJob([]);
    }
  };
  // To open status modal for updating candidate status
  const openStatusModal = async (candidate) => {
    setStatusModalCandidate(candidate);
    setSelectedStatus("");
    setRemarks("");
    setStatusModalOpen(true);

    // Fetch statuses when modal opens
    try {
      const statusResponse = await getAllStatuses();
      if (
        statusResponse &&
        statusResponse.status === "S" &&
        Array.isArray(statusResponse.result_info)
      ) {
        const statuses = statusResponse.result_info.map((status) => ({
          value: status.name,
          label: status.name,
          id: status.id,
        }));
        setStatusOptions(statuses);
      }
    } catch (error) {
      console.error("Error fetching statuses:", error);
    }
  };

  const handleUnAssignCandidate = async (candidate) => {
    const userId = localStorage.getItem("user_id");

    // Only handle unassign operation
    const payload = {
      requisition_id: selectedRequisition?.value || selectedRequisition?.id,
      candidate_id: candidate?.candidate?.id,
      updated_by: userId ? parseInt(userId) : 1,
    };

    try {
      // Show loading
      Swal.fire({
        html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
        // title: "Unassigning candidate...",
      });

      const res = await unassignCandidate(payload);
      Swal.close();

      if (res && res.status === "S") {
        // Refresh the data after successful unassignment
        await handleRequisitionChange(selectedRequisition);
        Swal.fire({
          icon: "success",
          title: "Candidate is now unassigned",
          confirmButtonColor: "#0078b9",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: res?.message || "Unassignment failed!",
          confirmButtonColor: "#0078b9",
        });
      }
    } catch (err) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Unassignment failed!",
        confirmButtonColor: "#0078b9",
      });
    }
  };

  const handleUpdateStatus = async () => {
    if (!selectedStatus) {
      Swal.fire({ icon: "warning", title: "Please select a status." });
      return;
    }

    const userId = localStorage.getItem("user_id");

    // Determine the correct requisition_id based on log type
    let requisitionId;
    if (logType?.value === "requisition") {
      requisitionId = selectedRequisition?.value || selectedRequisition?.id;
    } else if (logType?.value === "candidate") {
      // For candidate log, we need to get the job ID from the statusModalCandidate
      requisitionId =
        statusModalCandidate?.job_id || statusModalCandidate?.requisition_id;
    }

    // Validate requisition_id
    if (!requisitionId) {
      Swal.fire({
        icon: "error",
        title: "Invalid requisition ID. Please try again.",
        confirmButtonColor: "#0078b9",
      });
      return;
    }
  // Only validate target allocation for recruiters (roleId === "4")
// Hiring managers (roleId === "3") can always update status
if ((selectedStatus === "Joined" || selectedStatus === 31)) {
  try {
    const recruiterMappingsRes = await getRecruiterMappings(requisitionId);
    if (recruiterMappingsRes?.result_code === 200 && recruiterMappingsRes.result_info?.recruiter_details) {
      const currentRecruiterMapping = recruiterMappingsRes.result_info.recruiter_details.find(
        (r) => Number(r.id) === Number(userId)
      );
      
      // Check latest mapping target — recruiter must have target > 0
      if (!currentRecruiterMapping || Number(currentRecruiterMapping.recruiter_target || 0) === 0) {
        Swal.fire({
          icon: "error",
          title: "Insufficient Target Allocation",
          text: " The recruiter does not have sufficient target allocation to complete the status update.",
          confirmButtonColor: "#0078b9",
        });
        return;
      }
    }
  } catch (error) {
    console.error("Error checking recruiter target:", error);
  }
}

    const payload = {
      requisition_id: requisitionId,
      candidate_id: statusModalCandidate?.candidate?.id,
      new_status: selectedStatus,
      updated_by: userId ? parseInt(userId) : 1,
    };

    console.log("Update Status Payload:", payload);

    try {
      Swal.fire({
        html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });
      const res = await updateCandidateStatus(payload);
      Swal.close();

      if (res && res.result_code === 200) {
        setStatusModalOpen(false);

        // Show success message
        Swal.fire({
          icon: "success",
          title: "Status updated successfully!",
          confirmButtonColor: "#0078b9",
        });

        // Reload data based on log type with loader
        if (logType?.value === "requisition") {
          // Reload candidates for requisition
          await handleRequisitionChange(selectedRequisition);
        } else if (logType?.value === "candidate") {
          // Reload jobs for candidate
          await handleCandidateChange(selectedCandidate);
        }
      } else {
        Swal.fire({
          icon: "error",
          title: res?.error_info || "Status update failed!",
          confirmButtonColor: "#0078b9",
        });
      }
    } catch (err) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Status update failed!",
        confirmButtonColor: "#0078b9",
      });
    }
  };

  // Get available status options based on current status using getAllStatuses data
  const getAvailableStatusOptions = (currentStatus) => {
    if (!statusOptions || statusOptions.length === 0) return [];

    // Debug: Log available statuses from API
    console.log(
      "Available statuses from API:",
      statusOptions.map((s) => s.value)
    );
    console.log("Current status:", currentStatus);

    // Remove duplicate status names (keep only the first occurrence)
    const uniqueStatusOptions = statusOptions.filter(
      (status, index, self) =>
        index === self.findIndex((s) => s.value === status.value)
    );

    console.log(
      "Unique statuses after deduplication:",
      uniqueStatusOptions.map((s) => s.value)
    );

    // Create a mapping of status names to their IDs from the API response
    const statusNameToId = {};
    uniqueStatusOptions.forEach((status) => {
      statusNameToId[status.value] = status.id;
    });

    // Create dynamic flow based on ID sequences
    const createDynamicFlow = () => {
      const flow = {};

      // Get all unique statuses sorted by ID
      const sortedStatuses = uniqueStatusOptions.sort((a, b) => a.id - b.id);

      // Define the flow based on ID sequences
      // Assigned (hardcoded) -> Internal Screen Select (ID 1)
      flow["Assigned"] = ["Internal Screen Select", "Internal Screen Reject"];

      // Internal Screen Select (ID 1) -> Sent to Client (ID 3)
      flow["Internal Screen Select"] = ["Sent to Client"];

      // Internal Screen Reject (ID 2) -> End of pipeline
      flow["Internal Screen Reject"] = [];

      // Sent to Client (ID 3) -> Client Screen Select (ID 4), Client Screen Reject (ID 5), Requirement Hold (ID 6)
      flow["Sent to Client"] = [
        "Client Screen Select",
        "Client Screen Reject",
        "Requirement Hold",
      ];

      // Client Screen Select (ID 4) -> L1 Scheduled (ID 7)
      flow["Client Screen Select"] = ["L1 Scheduled"];

      // Client Screen Reject (ID 5) -> End of pipeline
      flow["Client Screen Reject"] = [];

      // Requirement Hold (ID 6) -> End of pipeline
      flow["Requirement Hold"] = [];

      // L1 Scheduled (ID 7) -> L1 Feedback Pending (ID 8), L1-Select (ID 9), L1-Reject (ID 10), No Show (ID 11), Requirement Hold (ID 12)
      flow["L1 Scheduled"] = [
        "L1 Feedback Pending",
        "L1-Select",
        "L1-Reject",
        "No Show",
        "Requirement Hold",
      ];

      // L1 Feedback Pending (ID 8) -> End of pipeline
      flow["L1 Feedback Pending"] = [];

      // L1-Select (ID 9) -> L2 Scheduled (ID 13)
      flow["L1-Select"] = ["L2 Scheduled"];

      // L1-Reject (ID 10) -> End of pipeline
      flow["L1-Reject"] = [];

      // No Show (ID 11) -> End of pipeline
      flow["No Show"] = [];

      // Requirement Hold (ID 12) -> End of pipeline
      flow["Requirement Hold"] = [];

      // L2 Scheduled (ID 13) -> L2 Feedback Pending (ID 14), L2-Select (ID 15), L2-Reject (ID 16), No Show (ID 17), Requirement Hold (ID 18)
      flow["L2 Scheduled"] = [
        "L2 Feedback Pending",
        "L2-Select",
        "L2-Reject",
        "No Show",
        "Requirement Hold",
      ];

      // L2 Feedback Pending (ID 14) -> End of pipeline
      flow["L2 Feedback Pending"] = [];

      // L2-Select (ID 15) -> Client Round Scheduled (ID 19)
      flow["L2-Select"] = ["Client Round Scheduled"];

      // L2-Reject (ID 16) -> End of pipeline
      flow["L2-Reject"] = [];

      // No Show (ID 17) -> End of pipeline
      flow["No Show"] = [];

      // Requirement Hold (ID 18) -> End of pipeline
      flow["Requirement Hold"] = [];

      // Client Round Scheduled (ID 19) -> Client Round Feedback Pending (ID 20), Client Round-Select (ID 21), Client Round-Reject (ID 22), Client Round-Hold (ID 23), Client Round-No Show (ID 24)
      flow["Client Round Scheduled"] = [
        "Client Round Feedback Pending",
        "Client Round-Select",
        "Client Round-Reject",
        "Client Round-Hold",
        "Client Round-No Show",
      ];

      // Client Round Feedback Pending (ID 20) -> End of pipeline
      flow["Client Round Feedback Pending"] = [];

      // Client Round-Select (ID 21) -> HR Discussion (ID 25)
      flow["Client Round-Select"] = ["HR Discussion"];

      // Client Round-Reject (ID 22) -> End of pipeline
      flow["Client Round-Reject"] = [];

      // Client Round-Hold (ID 23) -> End of pipeline
      flow["Client Round-Hold"] = [];

      // Client Round-No Show (ID 24) -> End of pipeline
      flow["Client Round-No Show"] = [];

      // HR Discussion (ID 25) -> BGV Inprogress (ID 26)
      flow["HR Discussion"] = ["BGV Inprogress"];

      // BGV Inprogress (ID 26) -> Offer Inprogress (ID 27)
      flow["BGV Inprogress"] = ["Offer Inprogress"];

      // Offer Inprogress (ID 27) -> Offer Released (ID 28)
      flow["Offer Inprogress"] = ["Offer Released"];

      // Offer Released (ID 28) -> Offer Accepted (ID 29), Offer Declined (ID 30)
      flow["Offer Released"] = ["Offer Accepted", "Offer Declined"];

      // Offer Accepted (ID 29) -> Joined (ID 31), Joining No Show (ID 32)
      flow["Offer Accepted"] = ["Joined", "Joining No Show"];

      // Joined (ID 31) -> End of pipeline
      flow["Joined"] = [];

      // Joining No Show (ID 32) -> End of pipeline
      flow["Joining No Show"] = [];

      // Offer Declined (ID 30) -> End of pipeline
      flow["Offer Declined"] = [];

      return flow;
    };

    const statusFlowNames = createDynamicFlow();

    // Get available next statuses for current status
    const availableNextStatusNames = statusFlowNames[currentStatus] || [];
    console.log(
      "Expected next statuses for",
      currentStatus,
      ":",
      availableNextStatusNames
    );

    // Create options array with "Assigned" as base option
    const allOptions = [
      { value: "Assigned", label: "Assigned", id: "assigned" },
      ...uniqueStatusOptions,
    ];

    // Create a smart mapping for duplicate status names based on context
    const getCorrectStatusId = (statusName, currentStatus) => {
      // For "Requirement Hold", return the appropriate ID based on current status
      if (statusName === "Requirement Hold") {
        if (currentStatus === "Sent to Client") return 6; // First occurrence
        if (currentStatus === "L1 Scheduled") return 12; // Second occurrence
        if (currentStatus === "L2 Scheduled") return 18; // Third occurrence
      }

      // For "No Show", return the appropriate ID based on current status
      if (statusName === "No Show") {
        if (currentStatus === "L1 Scheduled") return 11; // First occurrence
        if (currentStatus === "L2 Scheduled") return 17; // Second occurrence
      }

      // For other statuses, return the first occurrence
      const status = uniqueStatusOptions.find((s) => s.value === statusName);
      return status ? status.id : null;
    };

    // Create filtered options with correct IDs
    const createFilteredOptions = () => {
      const options = [];

      // Add current status first
      const currentStatusOption = allOptions.find(
        (option) => option.value === currentStatus
      );
      if (currentStatusOption) {
        options.push({
          ...currentStatusOption,
          isDisabled: true,
        });
      }

      // Add available next statuses with correct IDs
      availableNextStatusNames.forEach((statusName) => {
        const correctId = getCorrectStatusId(statusName, currentStatus);
        if (correctId !== null) {
          options.push({
            value: statusName,
            label: statusName,
            id: correctId,
            isDisabled: false,
          });
        }
      });

      return options;
    };

    // If no next statuses available, only show current status as disabled
    if (availableNextStatusNames.length === 0) {
      const currentStatusOption = allOptions.find(
        (option) => option.value === currentStatus
      );
      if (currentStatusOption) {
        return [
          {
            ...currentStatusOption,
            isDisabled: true,
          },
        ];
      }
      return [];
    }

    // Get filtered options with correct IDs
    const filteredOptions = createFilteredOptions();

    console.log(
      "Filtered options with correct IDs:",
      filteredOptions.map((opt) => ({ value: opt.value, id: opt.id }))
    );

    // Sort options: current status first (disabled), then others by ID
    const sortedOptions = filteredOptions.sort((a, b) => {
      // Current status always comes first
      if (a.value === currentStatus) return -1;
      if (b.value === currentStatus) return 1;

      // For other options, sort by ID
      const aId = a.id === "assigned" ? 0 : a.id;
      const bId = b.id === "assigned" ? 0 : b.id;
      return aId - bId;
    });

    return sortedOptions;
  };

  return (
    <div className="logs-container">
      <h2 style={{ fontWeight: 600, fontSize: "1.4rem", marginBottom: "24px" }}>
        Logs
      </h2>
      <div className="logs-section">
        {/* For Logtype selection */}
        <div className="logs-field">
          <label>Log Type *</label>
          <Select
            options={logTypeOptions}
            value={logType}
            onChange={handleLogTypeChange}
            placeholder="Select log type"
            isSearchable={true}
            classNamePrefix="react-select"
            styles={{
              menu: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({
                ...base,
                borderRadius: 6,
                border: "1.5px solid #d1d5db",
                minHeight: "42px",
              }),
              placeholder: (base) => ({
                ...base,
                color: "#6b7280",
              }),
              input: (base) => ({
                ...base,
                color: "#374151",
              }),
            }}
          />
        </div>
        {logType?.value === "candidate" && (
          <div className="logs-field">
            <label>Select Candidate *</label>
            <Select
              options={candidates}
              value={selectedCandidate}
              onChange={handleCandidateChange}
              placeholder="Search and select candidate"
              isSearchable={true}
              classNamePrefix="react-select"
              styles={{
                menu: (base) => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                  ...base,
                  borderRadius: 6,
                  border: "1.5px solid #d1d5db",
                  minHeight: "42px",
                }),
                placeholder: (base) => ({
                  ...base,
                  color: "#6b7280",
                }),
                input: (base) => ({
                  ...base,
                  color: "#374151",
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isFocused ? "#e5e7eb" : "white",
                  color: "#374151",
                  cursor: "pointer",
                }),
              }}
            />
          </div>
        )}
        {logType?.value === "requisition" && (
          <div className="logs-field">
            <label>Select Requisition *</label>
            <Select
              options={requisitions}
              value={selectedRequisition}
              onChange={handleRequisitionChange}
              placeholder="Search and Select Requisition"
              isSearchable={true}
              classNamePrefix="react-select"
              styles={{
                menu: (base) => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                  ...base,
                  borderRadius: 6,
                  border: "1.5px solid #d1d5db",
                  minHeight: "42px",
                }),
                placeholder: (base) => ({
                  ...base,
                  color: "#6b7280",
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isFocused ? "#e5e7eb" : "white",
                  color: "#374151",
                  cursor: "pointer",
                }),
              }}
            />
          </div>
        )}
        {loading && <div className="loading-message">Loading...</div>}
        {/* Jobs for Candidate */}
        {logType?.value === "candidate" &&
          selectedCandidate &&
          jobsForCandidate.length > 0 && (
            <div className="logs-results">
              <h3>Jobs</h3>
              <div className="logs-table">
                <table>
                  <thead>
                    <tr>
                      <th>Job ID</th>
                      <th>Job Title</th>
                      <th>Assigned At</th>
                      <th>Status</th>
                      <th>Remarks</th>
                      {/* <th>Actions</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {jobsForCandidate.map((job) => (
                      <tr key={job.id}>
                        <td>{job?.requisition?.job_id}</td>
                        <td>{job?.requisition?.job_title}</td>
                        <td>
                          {job?.assigned_at
                            ? new Date(job.assigned_at)
                                .toLocaleDateString("en-GB")
                                .split("/")
                                .join("-")
                            : "-"}
                        </td>
                        <td>{job?.status}</td>
                        <td>{job?.requisition?.remarks}</td>
                        {/* <td>
                          <button
                            className="assign-btn"
                            style={{
                              padding: "0.4rem 1rem",
                              fontSize: "0.95rem",
                              minWidth: 120,
                              background: "#0078B9",
                              color: "#fff",
                              border: "1.5px solid #0078b9",
                              fontWeight: 600,
                              transition: "all 0.2s",
                              marginRight: "8px",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleAssignJob(job);
                            }}
                          >
                            Unassign
                          </button>
                        </td> */}
                        {/* {roleId !== "4" && (
                          <button
                            className="assign-btn"
                            style={{
                              padding: "0.4rem 1rem",
                              fontSize: "0.95rem",
                              minWidth: 120,
                              background: "#f1f5f9",
                              color: "#0078b9",
                              border: "1.5px solid #0078b9",
                              fontWeight: 600,
                              transition: "all 0.2s",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              openStatusModal(job);
                            }}
                          >
                            Update Status
                          </button>
                        )} */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        {/* Candidates for Requisition */}
        {logType?.value === "requisition" &&
          selectedRequisition &&
          candidatesForJob.length > 0 && (
            <div className="logs-results">
              <h3>Candidates</h3>
              <div className="logs-table">
                <table>
                  <thead>
                    <tr>
                      <th>Assigned Date</th>
                      <th>Candidate Name</th>
                      <th>Current Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {candidatesForJob.map((candidate) => (
                      <tr key={candidate.id}>
                        <td>
                          {candidate.assigned_at
                            ? new Date(candidate.assigned_at)
                                .toLocaleDateString("en-GB")
                                .split("/")
                                .join("-")
                            : "-"}
                        </td>
                        <td>{candidate?.candidate?.candidate_name}</td>
                        <td>{candidate?.status}</td>
                        <td>
                          <button
                            className="assign-btn"
                            style={{
                              padding: "0.4rem 1rem",
                              fontSize: "0.95rem",
                              minWidth: 120,
                              background: "#0078B9",
                              color: "#fff",
                              border: "1.5px solid #0078B9",
                              fontWeight: 600,
                              transition: "all 0.2s",
                              marginRight: "8px",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleUnAssignCandidate(candidate);
                            }}
                          >
                            Unassign
                          </button>
                          {/* Hide Update Status button for Recruiter (role_id 4) */}
                          {roleId !== "4" && (
                            <button
                              className="assign-btn"
                              style={{
                                padding: "0.4rem 1rem",
                                fontSize: "0.95rem",
                                minWidth: 120,
                                background: "#f1f5f9",
                                color: "#0078b9",
                                border: "1.5px solid #0078b9",
                                fontWeight: 600,
                                transition: "all 0.2s",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                openStatusModal(candidate);
                              }}
                            >
                              Update Status
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        {/* No data found text */}
        {((logType?.value === "candidate" &&
          selectedCandidate &&
          jobsForCandidate.length === 0) ||
          (logType?.value === "requisition" &&
            selectedRequisition &&
            candidatesForJob.length === 0)) &&
          !loading && (
            <div className="no-data-message">
              No data found for the selected{" "}
              {logType?.value === "candidate" ? "candidate" : "requisition"}.
            </div>
          )}
        {/* Status Update Modal - Hide for Recruiter (role_id 4) */}
        {statusModalOpen && roleId !== "4" && (
          <div
            className="modal-overlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.25)",
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              className="modal-content"
              style={{
                background: "#fff",
                borderRadius: 10,
                padding: 32,
                minWidth: 500,
                width: "500px",
                boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
              }}
            >
              <h3 style={{ marginBottom: 18, fontWeight: 600 }}>
                Update Status
              </h3>
              <div style={{ marginBottom: 16 }}>
                <label
                  style={{ fontWeight: 500, marginBottom: 6, display: "block" }}
                >
                  Select Status *
                </label>
                <Select
                  options={getAvailableStatusOptions(
                    statusModalCandidate?.status
                  )}
                  onMenuOpen={() => {
                    console.log(
                      "Modal opened with candidate:",
                      statusModalCandidate
                    );
                    console.log(
                      "Status being passed:",
                      statusModalCandidate?.status
                    );
                  }}
                  value={
                    selectedStatus
                      ? { value: selectedStatus, label: selectedStatus }
                      : null
                  }
                  onChange={(selected) =>
                    setSelectedStatus(selected ? selected.value : "")
                  }
                  placeholder="Select status"
                  isSearchable={true}
                  classNamePrefix="react-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: 6,
                      border: "1.5px solid #d1d5db",
                      minHeight: "42px",
                    }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                    placeholder: (base) => ({
                      ...base,
                      color: "#6b7280",
                    }),
                    input: (base) => ({
                      ...base,
                      color: "#374151",
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isDisabled
                        ? "#f3f4f6"
                        : state.isFocused
                        ? "#e5e7eb"
                        : "white",
                      color: state.isDisabled ? "#9ca3af" : "#374151",
                      cursor: state.isDisabled ? "not-allowed" : "default",
                    }),
                  }}
                />
              </div>
              <div
                style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}
              >
                <button
                  style={{
                    padding: "0.5rem 1.2rem",
                    background: "#e5e7eb",
                    border: "none",
                    borderRadius: 6,
                    fontWeight: 500,
                  }}
                  onClick={() => setStatusModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  style={{
                    padding: "0.5rem 1.2rem",
                    background: "#0078b9",
                    color: "#fff",
                    border: "none",
                    borderRadius: 6,
                    fontWeight: 500,
                  }}
                  onClick={handleUpdateStatus}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Logs;
